var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.54,
    height: 128,
    viewBox: "0 0 30.54 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12573",
    "data-name": "Group 12573",
    transform: "translate(-33 -405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11655",
    "data-name": "Group 11655",
    transform: "translate(33 405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11389",
    "data-name": "Group 11389",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M305.2,250.469a15.27,15.27,0,1,0,15.27-15.27,15.271,15.271,0,0,0-15.27,15.27",
    transform: "translate(-305.198 -186.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M305.2,393.269A15.27,15.27,0,1,0,320.468,378a15.271,15.271,0,0,0-15.27,15.27",
    transform: "translate(-305.198 -280.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M305.2,107.669a15.27,15.27,0,1,0,15.27-15.27,15.271,15.271,0,0,0-15.27,15.27",
    transform: "translate(-305.198 -92.399)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/Ellipse.2b0b8c74f1ec70f470a07b823f71afd5.svg";
export { ForwardRef as ReactComponent };